import { css } from 'styled-components'

export const FadeIn = css`
  @keyframes fadeIn {
    from {
      visibility: hidden;
      opacity: 0;
    }
    to {
      visibility: visible;
      opacity: 1;
    }
  }
`
